var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-table"},[_c('AutoTable',{attrs:{"data":_vm.questions,"row-key":"uuid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }